module.exports = __webpack_public_path__ + "static/img/38c8b6b2752bbf8d3b033dbd05efa226.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_pro3.jpg
// module id = VArK
// module chunks = 1